import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as C from '../../../../../../constants';
export default function FloorCircle({ className, floorLevel, floorStatus, showFloorOccupancy, selectLocation, floor, isSelected, floorShortName, }) {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: className, onClick: () => selectLocation === null || selectLocation === void 0 ? void 0 : selectLocation(Object.assign({}, (floor !== null && floor !== void 0 ? floor : {}))) }, { children: _jsx("div", Object.assign({ className: "circle one" }, { children: _jsxs("div", Object.assign({ className: "circle two" }, { children: [_jsx("div", Object.assign({ className: "floor-level" }, { children: floorShortName })), showFloorOccupancy && floorStatus && (_jsx("div", Object.assign({ className: "floor-status" }, { children: t(`current-occupancy.${floorStatus}`) }))), isSelected && _jsx(YouAreHere, { t: t })] })) })) })));
}
function YouAreHere({ t }) {
    return (_jsx("div", Object.assign({ className: "you-are-here" }, { children: _jsx("div", { children: t(C.YOU_ARE_HERE) }) })));
}
FloorCircle.propTypes = {
    className: PropTypes.string.isRequired,
    floorLevel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    floorStatus: PropTypes.string,
    isSelected: PropTypes.bool,
    showFloorOccupancy: PropTypes.bool,
};
FloorCircle.defaultProps = {
    floorStatus: '',
    floorLevel: '',
    isSelected: false,
    floorShortName: '',
    showFloorOccupancy: true,
};
